document.addEventListener('DOMContentLoaded', function() {
  console.log('Gallery Timeline script initialized - Date-Based Version');
  
  // Main section element
  const galleryTimelineSection = document.querySelector('.section-gallery-timeline');
  if (!galleryTimelineSection) {
    console.error('Gallery Timeline section not found');
    return;
  }
  
  // ==============================
  // ELEMENTS
  // ==============================
  
  // Accordion Controls
  const controlButtons = galleryTimelineSection.querySelectorAll('.control-button');
  const accordionPanels = galleryTimelineSection.querySelectorAll('.accordion-panel');
  
  // Gallery Elements
  const galleryImages = galleryTimelineSection.querySelectorAll('.gallery-block__image-wrapper');
  
  // Timeline Elements
  const timelineTrack = galleryTimelineSection.querySelector('.timeline-track');
  
  // Shared Modal
  const sharedModal = document.getElementById('sharedModal');
  if (!sharedModal) {
    console.error('Shared modal not found');
    return;
  }
  
  const modalClose = sharedModal.querySelector('.modal-close');
  const modalContent = document.getElementById('modalContent');
  
  // Store image data by date
  const imagesByDate = {};
  
  // Simple touch variables for swipe
  let touchStartX = 0;
  let touchEndX = 0;
  
  // ==============================
  // DATA PROCESSING
  // ==============================
  
  // Collect all images and group them by date
  function collectImagesData() {
    console.log('Collecting images data...');
    
    galleryImages.forEach((imageWrapper) => {
      const date = imageWrapper.getAttribute('data-date');
      const imageId = imageWrapper.getAttribute('data-image-id');
      const img = imageWrapper.querySelector('img');
      
      if (date && img) {
        if (!imagesByDate[date]) {
          imagesByDate[date] = [];
        }
        
        imagesByDate[date].push({
          id: imageId,
          wrapper: imageWrapper,
          img: img,
          title: img.getAttribute('data-title'),
          caption: img.getAttribute('data-caption'),
          src: img.src,
          largeSrc: img.getAttribute('data-large-url'),
          alt: img.alt
        });
      }
    });
    
    console.log('Images grouped by date:', imagesByDate);
  }
  
  // Sort dates for proper display order
  function getSortedDates() {
    return Object.keys(imagesByDate).sort();
  }
  
  // ==============================
  // TIMELINE INITIALIZATION
  // ==============================
  
  function buildTimeline() {
    console.log('Building timeline...');
    
    const sortedDates = getSortedDates();
    
    // Clear existing timeline items
    if (timelineTrack) {
      timelineTrack.innerHTML = '';
    }
    
    sortedDates.forEach((date, index) => {
      if (timelineTrack) {
        const timelineItem = document.createElement('div');
        timelineItem.className = 'timeline-item';
        timelineItem.setAttribute('data-item-id', date);
        
        // Get first image of this date for thumbnail
        const images = imagesByDate[date];
        const firstImage = images[0];
        
        timelineItem.innerHTML = `
          <button class="timeline-trigger" aria-label="View ${date} details">
            <div class="timeline-thumbnail">
              <img src="${firstImage.src}" alt="${date}" loading="lazy">
            </div>
            <span class="timeline-decade">${date}</span>
          </button>
        `;
        
        timelineTrack.appendChild(timelineItem);
        
        // Add event listener
        const trigger = timelineItem.querySelector('.timeline-trigger');
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          openModalWithDate(date, 0, index);
        });
      }
    });
    
    console.log('Timeline built with', sortedDates.length, 'dates');
  }
  
  // ==============================
  // MODAL INITIALIZATION
  // ==============================
  
  function buildModalContent() {
    console.log('Building modal content...');
    
    const sortedDates = getSortedDates();
    
    // Clear existing modal content
    if (modalContent) {
      modalContent.innerHTML = '';
    }
    
    // Define SVG content for controls
    const prevSvg = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5 16.25L6.25 10L12.5 3.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
    
    const nextSvg = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 3.75L13.75 10L7.5 16.25" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
    
    sortedDates.forEach((date, dateIndex) => {
      const images = imagesByDate[date];
      
      // Create slide for this date
      const slide = document.createElement('div');
      slide.className = 'modal-slide';
      slide.id = `slide-${date.replace(/\s+/g, '-')}`;
      slide.setAttribute('data-slide-date', date);
      slide.setAttribute('data-slide-index', dateIndex);
      if (dateIndex > 0) slide.style.display = 'none';
      
      // Create gallery slider for images
      const gallerySlider = document.createElement('div');
      gallerySlider.className = 'modal-gallery-slider';
      
      // Add each image
      images.forEach((imageData, imgIndex) => {
        const sliderImage = document.createElement('div');
        sliderImage.className = `slider-image ${imgIndex === 0 ? 'active' : ''}`;
        sliderImage.setAttribute('data-slider-index', imgIndex);
        
        let captionHtml = '';
        if (imageData.title || imageData.caption) {
          captionHtml = `
            <div class="slider-caption">
              ${imageData.title ? `<h4>${imageData.title}</h4>` : ''}
              ${imageData.caption ? `<p>${imageData.caption}</p>` : ''}
            </div>
          `;
        }
        
        sliderImage.innerHTML = `
          <img src="${imageData.largeSrc || imageData.src}" alt="${imageData.alt}" loading="lazy">
          ${captionHtml}
        `;
        
        gallerySlider.appendChild(sliderImage);
      });
      
      // Add slider controls
      const controlsDiv = document.createElement('div');
      controlsDiv.className = 'slider-controls';
      
      const prevButton = document.createElement('button');
      prevButton.className = 'slider-control prev';
      prevButton.setAttribute('aria-label', 'Previous image');
      prevButton.innerHTML = prevSvg;
      prevButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        navigateSliderImage(slide, 'prev');
      });
      
      const nextButton = document.createElement('button');
      nextButton.className = 'slider-control next';
      nextButton.setAttribute('aria-label', 'Next image');
      nextButton.innerHTML = nextSvg;
      nextButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        navigateSliderImage(slide, 'next');
      });
      
      controlsDiv.appendChild(prevButton);
      controlsDiv.appendChild(nextButton);
      gallerySlider.appendChild(controlsDiv);
      
      // Create the timeline navigation
      const timelineNavigation = document.createElement('div');
      timelineNavigation.className = 'timeline-navigation';
      
      // Create dots container INSIDE timeline navigation
      const dotsContainer = document.createElement('div');
      dotsContainer.className = 'timeline-dots';
      
      // Add a dot for each image
      images.forEach((_, imgIndex) => {
        const dot = document.createElement('span');
        dot.className = `timeline-dot ${imgIndex === 0 ? 'active' : ''}`;
        dot.setAttribute('data-index', imgIndex);
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          changeActiveImage(slide, imgIndex);
        });
        dotsContainer.appendChild(dot);
      });
      
      // Create prev/next navigation buttons
      const navPrev = document.createElement('button');
      navPrev.className = 'nav-prev';
      navPrev.setAttribute('aria-label', 'Previous decade');
      navPrev.innerHTML = '❮';
      navPrev.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        navigateBetweenSlides('prev');
      });
      
      const navNext = document.createElement('button');
      navNext.className = 'nav-next';
      navNext.setAttribute('aria-label', 'Next decade');
      navNext.innerHTML = '❯';
      navNext.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        navigateBetweenSlides('next');
      });
      
      // Create years container with circular effect
      const yearsContainer = document.createElement('div');
      yearsContainer.className = 'years-container';
      yearsContainer.setAttribute('data-hide-scrollbar', 'true');
      
      // Create a circular list of years
      // First add the last few years at the beginning for a circular effect
      if (sortedDates.length > 1) {
        // Add the last 2 years at the beginning (or fewer if not enough dates)
        const prependCount = Math.min(2, sortedDates.length - 1);
        for (let i = sortedDates.length - prependCount; i < sortedDates.length; i++) {
          const year = sortedDates[i];
          const yearBtn = document.createElement('button');
          yearBtn.className = 'year-button';
          yearBtn.setAttribute('data-date', year);
          yearBtn.textContent = year;
          yearBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            openModalWithDate(year, 0);
          });
          yearsContainer.appendChild(yearBtn);
        }
      }
      
      // Add the main years
      sortedDates.forEach((year) => {
        const yearBtn = document.createElement('button');
        yearBtn.className = `year-button ${year === date ? 'active' : ''}`;
        yearBtn.setAttribute('data-date', year);
        yearBtn.textContent = year;
        yearBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          openModalWithDate(year, 0);
        });
        yearsContainer.appendChild(yearBtn);
      });
      
      // Add the first few years at the end for a circular effect
      if (sortedDates.length > 1) {
        // Add the first 2 years at the end (or fewer if not enough dates)
        const appendCount = Math.min(2, sortedDates.length - 1);
        for (let i = 0; i < appendCount; i++) {
          const year = sortedDates[i];
          const yearBtn = document.createElement('button');
          yearBtn.className = 'year-button';
          yearBtn.setAttribute('data-date', year);
          yearBtn.textContent = year;
          yearBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            openModalWithDate(year, 0);
          });
          yearsContainer.appendChild(yearBtn);
        }
      }
      
      // Assemble the timeline navigation
      timelineNavigation.appendChild(dotsContainer);
      timelineNavigation.appendChild(navPrev);
      timelineNavigation.appendChild(yearsContainer);
      timelineNavigation.appendChild(navNext);
      
      // Build the slide
      slide.appendChild(gallerySlider);
      slide.appendChild(timelineNavigation);
      modalContent.appendChild(slide);
      
      // Add simple touch events for swipe on images
      if ('ontouchstart' in window) { // Only add on touch devices
        gallerySlider.addEventListener('touchstart', function(e) {
          touchStartX = e.touches[0].clientX;
        }, { passive: true });
        
        gallerySlider.addEventListener('touchend', function(e) {
          touchEndX = e.changedTouches[0].clientX;
          handleSwipe(slide);
        }, { passive: true });
      }
    });
    
    console.log('Modal content built with', sortedDates.length, 'slides');
  }
  
  // Simple swipe handler - only for image navigation
  function handleSwipe(slide) {
    const diff = touchStartX - touchEndX;
    
    // If the touch registers a significant swipe
    if (Math.abs(diff) > 50) { // Minimum 50px to register as swipe
      if (diff > 0) {
        // Swipe left - next image
        navigateSliderImage(slide, 'next');
      } else {
        // Swipe right - previous image
        navigateSliderImage(slide, 'prev');
      }
    }
    
    // Reset touch coordinates
    touchStartX = 0;
    touchEndX = 0;
  }
  
  // ==============================
  // INITIALIZATION
  // ==============================
  
  // Initial setup function
  function init() {
    console.log('Initializing gallery timeline...');
    
    // Process image data
    collectImagesData();
    
    // Build timeline and modal
    buildTimeline();
    buildModalContent();
    
    // Initialize functionality
    initAccordion();
    initGallery();
    initModalInteractions();
    initMobileControls();
    
    // Initialize the first slide with proper dots
    setTimeout(() => {
      // Find the first slide
      const firstSlide = modalContent.querySelector('.modal-slide');
      if (firstSlide) {
        const date = firstSlide.getAttribute('data-slide-date');
        if (date) {
          changeActiveImage(firstSlide, 0);
          centerActiveYear(firstSlide);
        }
      }
    }, 300);
    
    console.log('Gallery timeline initialized successfully');
  }
  
  // ==============================
  // ACCORDION FUNCTIONALITY
  // ==============================
  
  function initAccordion() {
    controlButtons.forEach((button) => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const target = this.getAttribute('data-target');
        console.log('Tab navigation: Selected', target);
        
        // Update button states
        controlButtons.forEach((btn) => {
          btn.classList.remove('active');
          btn.setAttribute('aria-selected', 'false');
        });
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');
        
        // Update panel visibility
        accordionPanels.forEach((panel) => {
          if (panel.getAttribute('data-panel') === target) {
            panel.classList.add('active');
          } else {
            panel.classList.remove('active');
          }
        });
      });
    });
    console.log('Accordion initialized');
  }
  
  // ==============================
  // GALLERY FUNCTIONALITY
  // ==============================
  
  function initGallery() {
    galleryImages.forEach((imageWrapper) => {
      imageWrapper.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const date = this.getAttribute('data-date');
        const imageId = this.getAttribute('data-image-id');
        
        if (!date || !imageId) {
          console.error('Missing data attributes on image:', this);
          return;
        }
        
        // Find the image index within this date group
        let imageIndex = 0;
        const images = imagesByDate[date];
        if (images) {
          imageIndex = images.findIndex(img => img.id === imageId);
          if (imageIndex === -1) imageIndex = 0;
        }
        
        console.log('Gallery image clicked:', 'Date:', date, 'Image Index:', imageIndex);
        
        // Open the modal with the selected date and image
        openModalWithDate(date, imageIndex);
      });
    });
    console.log('Gallery initialized with', galleryImages.length, 'images');
  }
  
  // ==============================
  // MODAL FUNCTIONALITY
  // ==============================
  
  function openModalWithDate(date, imageIndex = 0, dateIndex = null) {
    console.log('Opening modal with date:', date, 'Image index:', imageIndex);
    
    // Find date index if not provided
    if (dateIndex === null) {
      const sortedDates = getSortedDates();
      dateIndex = sortedDates.indexOf(date);
    }
    
    // Hide all slides
    const allSlides = modalContent.querySelectorAll('.modal-slide');
    allSlides.forEach(slide => {
      slide.style.display = 'none';
    });
    
    // Show the selected slide
    const targetSlide = document.querySelector(`[data-slide-date="${date}"]`);
    if (targetSlide) {
      targetSlide.style.display = 'block';
      
      // Show the specific image
      changeActiveImage(targetSlide, imageIndex);
      
      // Center the active year with a slight delay to ensure rendering
      setTimeout(() => {
        centerActiveYear(targetSlide);
      }, 50);
      
      // Show the modal
      sharedModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    } else {
      console.error('Target slide not found:', date);
    }
  }
  
  // Improved function to ensure centering
  function centerActiveYear(slide) {
    const yearsContainer = slide.querySelector('.years-container');
    const activeYear = yearsContainer.querySelector('.year-button.active');
    
    if (yearsContainer && activeYear) {
      // Get the dimensions
      const containerWidth = yearsContainer.offsetWidth;
      const buttonWidth = activeYear.offsetWidth;
      const buttonLeft = activeYear.offsetLeft;
      
      // Calculate center position
      const scrollPosition = buttonLeft - (containerWidth / 2) + (buttonWidth / 2);
      
      // Disable pointer events briefly during scroll to avoid showing scrollbar
      yearsContainer.style.pointerEvents = 'none';
      
      // Set scroll position immediately
      yearsContainer.scrollLeft = scrollPosition;
      
      // Multiple timeouts to ensure centering works
      [10, 50, 100, 200, 500].forEach(timeout => {
        setTimeout(() => {
          yearsContainer.scrollLeft = scrollPosition;
          
          // Re-enable pointer events after the last timeout
          if (timeout === 500) {
            yearsContainer.style.pointerEvents = 'auto';
          }
        }, timeout);
      });
    }
  }
  
  function changeActiveImage(slide, newIndex) {
    const sliderImages = slide.querySelectorAll('.slider-image');
    if (sliderImages.length === 0) return;
    
    // Validate newIndex
    if (newIndex < 0 || newIndex >= sliderImages.length) {
      console.warn('Invalid image index:', newIndex, 'Max:', sliderImages.length - 1);
      return;
    }
    
    // Update image visibility
    sliderImages.forEach((img, idx) => {
      img.classList.toggle('active', idx === newIndex);
    });
    
    // Update dots
    const dots = slide.querySelectorAll('.timeline-dot');
    dots.forEach((dot, idx) => {
      dot.classList.toggle('active', idx === newIndex);
    });
  }
  
  function navigateSliderImage(slide, direction) {
    const sliderImages = slide.querySelectorAll('.slider-image');
    if (sliderImages.length <= 1) return;
    
    // Find current active image
    let currentIndex = -1;
    sliderImages.forEach((img, idx) => {
      if (img.classList.contains('active')) {
        currentIndex = idx;
      }
    });
    
    if (currentIndex === -1) {
      currentIndex = 0;
    }
    
    // Calculate new index
    let newIndex;
    if (direction === 'prev') {
      newIndex = (currentIndex - 1 + sliderImages.length) % sliderImages.length;
    } else {
      newIndex = (currentIndex + 1) % sliderImages.length;
    }
    
    // Change to the new image
    changeActiveImage(slide, newIndex);
    
    // Analytics
    console.log(`Navigated from image ${currentIndex} to ${newIndex} (${direction})`);
  }
  
  function navigateBetweenSlides(direction) {
    console.log('Navigating between slides:', direction);
    
    const activeSlide = modalContent.querySelector('.modal-slide[style*="display: block"]');
    if (!activeSlide) return;
    
    const currentDate = activeSlide.getAttribute('data-slide-date');
    const sortedDates = getSortedDates();
    const currentIndex = sortedDates.indexOf(currentDate);
    
    let newIndex;
    if (direction === 'prev') {
      newIndex = (currentIndex - 1 + sortedDates.length) % sortedDates.length;
    } else {
      newIndex = (currentIndex + 1) % sortedDates.length;
    }
    
    const newDate = sortedDates[newIndex];
    openModalWithDate(newDate, 0);
  }
  
  function closeModal() {
    console.log('Closing modal');
    sharedModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  
  // ==============================
  // MODAL INTERACTIONS
  // ==============================
  
  function initModalInteractions() {
    // Close button
    if (modalClose) {
      modalClose.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
    }
    
    // Click outside to close
    if (sharedModal) {
      sharedModal.addEventListener('click', function(e) {
        if (e.target === sharedModal) {
          closeModal();
        }
      });
    }
    
    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      if (sharedModal && sharedModal.getAttribute('aria-hidden') === 'false') {
        if (e.key === 'Escape') {
          closeModal();
        } else if (e.key === 'ArrowLeft') {
          // Move to previous image in current slide
          const activeSlide = modalContent.querySelector('.modal-slide[style*="display: block"]');
          if (activeSlide) {
            navigateSliderImage(activeSlide, 'prev');
          }
        } else if (e.key === 'ArrowRight') {
          // Move to next image in current slide
          const activeSlide = modalContent.querySelector('.modal-slide[style*="display: block"]');
          if (activeSlide) {
            navigateSliderImage(activeSlide, 'next');
          }
        } else if (e.key === 'ArrowUp') {
          navigateBetweenSlides('prev'); // Previous date
        } else if (e.key === 'ArrowDown') {
          navigateBetweenSlides('next'); // Next date
        }
      }
    });
    
    console.log('Modal interactions initialized');
  }
  
  // ==============================
  // MOBILE CONTROLS
  // ==============================
  
  function initMobileControls() {
    if (window.innerWidth > 768) return;
    
    const controlsElement = galleryTimelineSection.querySelector('.gallery-timeline-controls');
    if (!controlsElement) return;
    
    // Get the section for position tracking
    let sectionTop = galleryTimelineSection.getBoundingClientRect().top + window.scrollY;
    let sectionHeight = galleryTimelineSection.offsetHeight;
    
    // Update dimensions on window resize
    window.addEventListener('resize', function() {
      sectionTop = galleryTimelineSection.getBoundingClientRect().top + window.scrollY;
      sectionHeight = galleryTimelineSection.offsetHeight;
    });
    
    window.addEventListener('scroll', function() {
      const scrollY = window.scrollY;
      
      // Check if we're scrolling within the section
      if (scrollY >= sectionTop && scrollY <= (sectionTop + sectionHeight - window.innerHeight)) {
        controlsElement.classList.add('sticky');
      } else {
        controlsElement.classList.remove('sticky');
      }
    });
    
    console.log('Mobile controls initialized');
  }
  
  // ==============================
  // INITIALIZATION
  // ==============================
  
  // Wait for DOM to be fully ready
  setTimeout(init, 100);
});